module.exports = __webpack_public_path__ + "static/media/grid1-01_pixellated.36e933b3.jpg";